import { IEnvironment } from '@core/interfaces/common';

export const environment: IEnvironment = {
  production: false,
  fingerprintCaptureUrl: process.env['FINGERPRINT_CAPTURE_URL']!,
  apiUrl: process.env['API_URL']!,
  apiKey: process.env['API_KEY']!,
  pollingInterval: parseInt(process.env['POLLING_INTERVAL']!),
  docs: {
    version: process.env['DOCS_VERSION']!,
  },
  app: {
    version: process.env['APP_VERSION']!,
    url: process.env['APP_URL']!
  },
};
